module.exports = __webpack_public_path__ + "static/img/4906_phase_function_Paper_PointsHejduk_Prediction.b87f365.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4906_phase_function_Paper_PointsHejduk_Prediction.png
// module id = M0dj
// module chunks = 0